module.exports = __webpack_public_path__ + "static/media/take_care.0a42744e.webp";